import React from 'react';
import { Box, InputLabel, Typography, useTheme } from '@mui/material';
import { RiArrowDropDownFill } from 'react-icons/ri';
import { BsCalendar2Check } from 'react-icons/bs';
import { formatDate } from '../WidgetConfig';

import { CiCalendar } from 'react-icons/ci';

const DateSelector = ({ date, onClick, pid }) => {
  const theme = useTheme();

  return (
    <Box>
      <InputLabel
        sx={{
          fontSize: '12px',
          fontWeight: 800,
          color: 'text.secondary',
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
        }}
      >
        <CiCalendar className="text-[20px]" />
        Select Date
      </InputLabel>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          border: '1px solid',
          borderColor: 'divider',
          px: 2,
          mt: 1,
          boxSizing: 'border-box',
          borderRadius: '8px',
          height: '44px',
          cursor: 'pointer',
          bgcolor: 'background.paper',
        }}
        aria-describedby={pid}
        onClick={onClick}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BsCalendar2Check style={{ color: theme.palette.text.secondary }} />
          <Typography
            sx={{ fontWeight: 500, fontSize: '12px', color: 'text.primary' }}
          >
            {formatDate(date)}
          </Typography>
        </Box>
        <RiArrowDropDownFill style={{ fontSize: '20px' }} />
      </Box>
    </Box>
  );
};

export default DateSelector;
